import { setUser, setActiveRole } from '../user/userSlice';
import { api } from './api';
import type { SwitchRolePayload, LoginPayload, LoginResponse, SwitchRoleResponse, ResetPasswordPayload, ForgotPasswordPayload } from './auth.types';
import type { DefaultApiResponse } from './types/response';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginPayload>({
      query: ({ username, password }) => ({
        url: '/auth/login',
        method: 'POST',
        body: { username, password }
      }),
      onQueryStarted: async (_arg, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled;
        localStorage.setItem('jwt', data.jwt);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('activeRole', data.activeRole);
        dispatch(setActiveRole(data.activeRole));
        dispatch(setUser(data.user));
        dispatch(api.util.resetApiState());
      },
    }),
    switchRole: builder.mutation<SwitchRoleResponse, SwitchRolePayload>({
      query: (body) => ({
        url: '/auth/switch-role',
        method: 'POST',
        body
      }),
      onQueryStarted: async (_arg, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled;
        localStorage.setItem('jwt', data.jwt);
        localStorage.setItem('activeRole', data.activeRole);
        dispatch(setActiveRole(data.activeRole));
        dispatch(api.util.resetApiState());
      },
    }),
    resetPassword: builder.mutation<string, ResetPasswordPayload>({
      query: (body) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body
      }),
      transformResponse: (res: DefaultApiResponse) => res.message,
    }),
    forgotPassword: builder.mutation<string, ForgotPasswordPayload>({
      query: (body) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body
      }),
      transformResponse: (res: DefaultApiResponse) => res.message,
    }),
  }),
});

export const { useLoginMutation, useSwitchRoleMutation, useResetPasswordMutation, useForgotPasswordMutation } = authApi;